import { createSlice } from '@reduxjs/toolkit';

// User Slice
/**
 * A slice for authentication with `setAuth` action.
 * @typedef {Object} UserState
 * @property {string} _id The user Id
 * @property {string} fullName 
 * @property {string} email 
//  * @property {string} phone
 * @property {string|null} address - The user's address (nullable)
 * @property {number} action.payload.profilePic PRofilePic
 * @property {string} userType - The type of user (e.g., 'admin', 'business', 'customer')
 */
export const userSlice = createSlice({
    name: 'user',
    initialState: {
        _id: '',
        fullName: '',
        email: '',
        address: null,
        userType: '',
        profilePic: '',
    },
    reducers: {
        /**
        * Set user details.
        * @param {UserState} state - The current user state.
        * @param {Object} action - The dispatched action.
        * @param {Object} action.payload - The new user data.
        * @param {string} [action.payload._id]
        * @param {string} [action.payload.fullName]
        * @param {string} [action.payload.email]
        * @param {string|null} [action.payload.address]
        * @param {string} [action.payload.profilePic]
        * @param {string} [action.payload.userType]
        */
        updateUser: (state, action) => {
            return { ...state, ...action.payload };
        },
        emptyUser: (state, action) => {
            return {
                _id: '',
                fullName: '',
                email: '',
                address: null,
                profilePic: '',
                userType: '',
            };
        },
    },
});
export const { updateUser, emptyUser } = userSlice.actions;

